import { forwardRef, Ref, type SVGProps } from 'react';

const SvgPinIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3485}
      d="M12.795 8A4.795 4.795 0 0 1 8 12.795M12.795 8A4.795 4.795 0 0 0 8 3.206M12.795 8h1.199M8 12.795A4.795 4.795 0 0 1 3.206 8M8 12.795v1.199M3.206 8A4.795 4.795 0 0 1 8 3.206M3.206 8H2.007M8 3.206V2.007M9.798 8a1.798 1.798 0 1 1-3.596 0 1.798 1.798 0 0 1 3.596 0"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgPinIcon);
export default ForwardRef;
